export default {
  PRODUCT_REPEATER_CLASS: 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop',
  TOTAL_HITS: 'products',

  FACET_TITLE_ICON: `
    <rt-virtual rt-if="this.isCollapsed" template="icons/plus" />
    <rt-virtual rt-if="!this.isCollapsed" template="icons/minus" />`,
};
